import { createSlice } from '@reduxjs/toolkit';
import { createExtraReducersForThunk, createApiThunkPrivate } from '../_helpers/ApiThunk';

const initialState = {
    getListData: {}, createData: {}, editData: {}, enableDisableData: {},softDeleteBadgeData:{}
}

export const getBadgeList = createApiThunkPrivate('getBadgeList', '/badge/getList', 'GET')
export const createBadge = createApiThunkPrivate('createBadge', '/badge/create', 'POST')
export const editBadge = createApiThunkPrivate('editBadge', '/badge/update', 'PUT')
export const enableDisableBadge = createApiThunkPrivate('enableDisableBadge', '/badge/enableDisable', 'PUT')
export const softDeleteBadge = createApiThunkPrivate('softDeleteBadge', '/badge/softDelete', 'DELETE')

// export const getAllCountryList = createApiThunkPrivate('getAllCountryList', '/store/getAllDocuments', 'GET')
const badgeSlice = createSlice({
    name: 'badge',
    initialState,
    extraReducers: builder => {
        createExtraReducersForThunk(builder, getBadgeList, 'getListData')
        createExtraReducersForThunk(builder, createBadge, 'createData')
        createExtraReducersForThunk(builder, editBadge, 'editData')
        createExtraReducersForThunk(builder, enableDisableBadge, 'enableDisableData')
        createExtraReducersForThunk(builder, softDeleteBadge, 'softDeleteBadgeData')

        // createExtraReducersForThunk(builder, getAllCountryList, 'getAllCountryListData')

        // policy functions======>>>>>>>>>>>>>>
    }
})

export default badgeSlice.reducer 